import { connect } from 'react-redux';

import Appointment from '../components/Appointment';
import { startCancelRequest, startRequest } from '../redux/appointments/actions';
import { createStructuredSelector } from 'reselect';
import { bindActionCreators } from 'redux';
import {
  appointmentIdSlice,
  bookingSelector,
  appointmentsSlice,
  isAppointmentsPresentedSelector,
  cancelErrorSlice,
  isCanceledSlice,
  cancelLoadingSlice,
  isAppointmentsLoadingSelector,
} from 'modules/Contacts/selectors/appointmentSelectors';

const mapStateToProps = createStructuredSelector({
  appointments: appointmentsSlice,
  bookingId: appointmentIdSlice,
  bookingDetails: bookingSelector,
  cancelError: cancelErrorSlice,
  isDataPresented: isAppointmentsPresentedSelector,
  isCancelingAppointment: cancelLoadingSlice,
  isLoading: isAppointmentsLoadingSelector,
  isCanceled: isCanceledSlice,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAppointment: (bookId) => startRequest(bookId),
      cancelAppointment: (bookId) => startCancelRequest(bookId),
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Appointment);
